import TargetingService from "Services/targeting";

export const CHECK_CPS_AVAILABLE = "CHECK_CPS_AVAILABLE";

export const TARGETINGS_ALL_REQUESTED = "TARGETINGS_ALL_REQUESTED";
export const TARGETINGS_ALL_OK = "TARGETINGS_ALL_OK";
export const TARGETINGS_ALL_FAIL = "TARGETINGS_ALL_FAIL";

export function getTargetingsAll() {
  const targetings = {
    os_type: [
      { key: 1, title: "Desktop" },
      { key: 2, title: "Mobile" },
      { key: 3, title: "Other" },
    ],
    device_type: [
      { key: 1, title: "Desktop" },
      { key: 2, title: "Other" },
      { key: 3, title: "Phone" },
      { key: 4, title: "Tablet" },
      { key: 5, title: "TV" },
    ],
  };

  return (dispatch) => {
    const targetingKeys = [];

    const processResponse = (key, response) => {
      return response.then((result) => {
        return { key, data: result.data };
      });
    };

    const servicePromise = targetingKeys.map((key) =>
      processResponse(key, TargetingService.getTargetingsByType(key))
    );

    dispatch({ type: TARGETINGS_ALL_REQUESTED });

    Promise.all(servicePromise)
      .then((values) => {
        values.forEach((value) => {
          targetings[value.key] = value.data;
        });
        dispatch({
          type: TARGETINGS_ALL_OK,
          data: targetings,
        });
      })
      .catch((errors) => {
        dispatch({
          type: TARGETINGS_ALL_FAIL,
          errors,
        });
      });
  };
}

export function getTargetingLabel(targetings, type, id) {
  if (!targetings) {
    return "";
  }
  const data = targetings[type];
  if (!Array.isArray(data)) {
    return "";
  }

  if (type === "geo") {
    return id;
  }

  const t = data.find((item) => item.key === id);
  return t !== undefined && t.title ? t.title : "";
}

export function getOs() {
  return (dispatch) => {
    dispatch({ type: "GET_OS_LOADING" });

    TargetingService.getTargetingsOs()
      .then((result) => {
        dispatch({
          type: "GET_OS_OK",
          data: result,
        });
      })
      .catch((errors) => {
        dispatch({
          type: "GET_OS_ERROR",
          errors,
        });
      });
  };
}

export function getDevice() {
  return (dispatch) => {
    dispatch({ type: "GET_DEVICE_LOADING" });

    TargetingService.getTargetingsDevice()
      .then((result) => {
        dispatch({
          type: "GET_DEVICE_OK",
          data: result,
        });
      })
      .catch((errors) => {
        dispatch({
          type: "GET_DEVICE_ERROR",
          errors,
        });
      });
  };
}

export function getBrowser() {
  return (dispatch) => {
    dispatch({ type: "GET_BROWSER_LOADING" });

    TargetingService.getTargetingsBrowser()
      .then((result) => {
        dispatch({
          type: "GET_BROWSER_OK",
          data: result,
        });
      })
      .catch((errors) => {
        dispatch({
          type: "GET_BROWSER_ERROR",
          errors,
        });
      });
  };
}

export function getLanguage() {
  return (dispatch) => {
    dispatch({ type: "GET_LANGUAGE_LOADING" });

    TargetingService.getTargetingsLanguage()
      .then((result) => {
        dispatch({
          type: "GET_LANGUAGE_OK",
          data: result,
        });
      })
      .catch((errors) => {
        dispatch({
          type: "GET_LANGUAGE_ERROR",
          errors,
        });
      });
  };
}
